import { render, staticRenderFns } from "./my-task.vue?vue&type=template&id=1bfd2b04&scoped=true&"
import script from "./my-task.vue?vue&type=script&lang=js&"
export * from "./my-task.vue?vue&type=script&lang=js&"
import style0 from "./my-task.vue?vue&type=style&index=0&id=1bfd2b04&lang=less&scoped=true&"
import style1 from "./my-task.vue?vue&type=style&index=1&id=1bfd2b04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfd2b04",
  null
  
)

export default component.exports